import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import {
  BarLoader,
  Button,
  BUTTON_COLOR,
  BUTTON_THEME,
  IconButton,
  Pagination,
  usePagination,
} from '@st-operations/uikit/src/v2'

import Table from '../table'
import DetailsModal from '../details-modal'

import { getFreeUserRequests, freeUserApprove, freeUserDeny } from '_services/predactiv-admin'

const FreeUserTab = ({ env }) => {
  const [data, setData] = useState(null)
  const [viewing, setViewing] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const getItems = (response) =>
    response?.map((item) => ({
      data: item,
      values: [
        // Status
        <span
          style={{
            color: {
              ACCEPTED: '#13682B',
              PENDING: '#4267B2',
              REJECTED: '#BD081C',
            }[item.status],
          }}
        >
          {item.status}
        </span>,
        // Date Requested
        dayjs(item.created_at).format('D, MMM YYYY - HH:MM'),
        // Name
        item.name,
        // Email
        item.email,
        // Organization
        item.company_name,
      ],
    }))
  const items = getItems(data)
  const { page, toPage } = usePagination(items || [], 15)

  useEffect(() => {
    setData(null)
    setViewing(null)
    getFreeUserRequests(env)
      .then((resp) => setData(resp))
      .catch((err) => console.error('err', err))
  }, [env, refresh])

  const renderAction = (data) => (
    <>
      <IconButton
        onClick={() => setViewing(data)}
        aria-label="View Details"
        iconProps={{
          icon: 'info',
          type: 'outline',
          width: 16,
          height: 16,
          color: '#3D3C68',
        }}
      />
    </>
  )

  const handleApprove = () => {
    freeUserApprove({ env, id: viewing._id })
      .then(() => {
        toast.success('User approved!')
        setRefresh(Math.random())
      })
      .catch(() => toast.error('An error has occurred'))
  }

  const handleDeny = () => {
    freeUserDeny({ env, id: viewing._id })
      .then(() => {
        toast.success('User rejected!')
        setRefresh(Math.random())
      })
      .catch(() => toast.error('An error has occurred'))
  }

  if (!data) return <BarLoader />

  return (
    <div>
      <Table
        items={page.content}
        header={['Status', 'Date Requested', 'Name', 'Email', 'Organization']}
        renderAction={renderAction}
        gridTemplateColumns={'repeat(5, 1fr) min-content'}
      />
      <Pagination
        options={{ length: page.quantity }}
        page={page.number - 1}
        onPageChange={(page) => toPage(page.label)}
      />
      <Dialog open={!!viewing} onClose={() => setViewing(null)}>
        <DetailsModal
          env={env}
          data={viewing}
          actions={
            viewing?.status === 'PENDING'
              ? [
                  <Button
                    key={1}
                    onClick={handleDeny}
                    theme={BUTTON_THEME.SECONDARY}
                    color={BUTTON_COLOR.RED}
                  >
                    Deny
                  </Button>,
                  <Button key={2} onClick={handleApprove}>
                    Approve
                  </Button>,
                ]
              : []
          }
        />
      </Dialog>
    </div>
  )
}

export default FreeUserTab
